const getItems = <T> (item: T) => {
  if (item instanceof Join) {
    const items = [];
    for (let i = 0; i < item.items.length; i++) {
      items.push(...getItems(item.items[i]))
      if (item.items.length > (i + 1)) {
        items.push(item.by);
      }
    }
    return items;
  }
  return [ item ];
}

const split = <T> (strings: string[], ...keys: T[]): (string | T)[] => {
  const out = [];
  for (let ind = 0; ind < strings.length; ind++) {
    out.push(strings[ind]);
    const key = keys[ind];
    if (key) {
      const items = getItems(key);
      out.push(...items);
    }
  }
  return out;
}

export default split;

export class Join<T> {
  constructor(public items: T[], public by: string) {}
}

export class Link {
  constructor(public text: string, public link: string) {}
}

export const join = <T> (arr: T[], by: string) => new Join(arr, by);
export const link = (text: string, url: string) => new Link(text, url);